let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cno8Q")).then(() => parcelRequire('kYYal'));